module.exports = __webpack_public_path__ + "img/test_g.1fff207b.png";